import Section from 'containers/Learn/Articles/Section/Section';
import { IGeneralSection } from 'interfaces/IMarketing';
import { HEADER_SIZE } from './utils/getHeader.util';
import styles from './styles.module.scss';

interface ILayoutDProps {
  articles: IGeneralSection[];
  onDownloadClick: (value: string) => void;
  highestHeadingSize?: HEADER_SIZE;
}

const LayoutD = ({
  articles,
  onDownloadClick,
  highestHeadingSize = HEADER_SIZE.H1,
}: ILayoutDProps) => (
  <div className={styles.layoutD}>
    {articles.map((article) => (
      <Section
        article={article}
        className={styles.column}
        highestHeadingSize={highestHeadingSize}
        key={article.id}
        onDownloadClick={onDownloadClick}
      />
    ))}
    <Section
      className={styles.column}
      empty
      highestHeadingSize={highestHeadingSize}
    />
    <Section
      className={styles.column}
      empty
      highestHeadingSize={highestHeadingSize}
    />
  </div>
);

export default LayoutD;
